import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import { ComponentService } from '../../../services/component.service';
import { costantValue } from '../../../services/forms-template.service';
import { IPartner } from '../../../views/crm/interfaces';


@Component({
  selector: 'app-crm-sedi-contatto',
  templateUrl: './crmSediContatto.component.html',
  styleUrls: ['./crmSediContatto.component.css']
})
export class CrmSediContattoComponent implements OnInit {
  @Input() dataContatto: any;
  @Input() titolo: string = '';
  @Input() costantValues: costantValue[] = []
  @Input() service: string = '';
  @Input() api: string = 'diario';
  @Input() gridHeight: string = '600';
  @Input() filter: string = '';
  @Input() modifica: boolean = true
  @Input() aggiungi: boolean = true
  @Input() elimina: boolean = true
  @Input() TextAddRowButton = undefined
  @Input() soloRicercaGlobale: boolean = true
  @Input() ricerca: boolean = false
  @Input() isAdvancedXlsExportAvailable: boolean = false
  @Input() isExportDocxAvailable: boolean = true
  @Input() isExportExcelAvailable: boolean = true
  @Input() isExportPDFAvailable: boolean = true
  @Input() gridWidth
  @Input() chiaviDettagli
  @Output() onAllEventEmitter: EventEmitter<any> = new EventEmitter<any>()
  public partnerData: IPartner = {
    isPartner: false,
    isSegreteria: false,
    id: null
  };
  nuovoInserimento: boolean = false;
  constructor(private componentService: ComponentService) { }
  ngOnInit(): void {

  }
  allEventAnagrafica(event) {
    console.log(event)
    if (event.name === "submittedInsertOk" && this.nuovoInserimento) {
      this.componentService.destroyCurrentOpenPopUp('CrmSediContattoComponent')
      this.componentService.destroyCurrentOpenPopUp('CrmDettagliProcedureContattiComponent')
      this.componentService.destroyOutputComponent();
      // this.componentService.destroyCurrentOpenPopUpByGuid(event.guid)
      let guid = Math.random().toString().replace("0.", "")
      const titolo = `Riepilogo Procedure di:  ${this.dataContatto.RagSoc}`
      let dataToSend = {
        queryString: `/${this.dataContatto.Cod}`,
        dataRelated: this.dataContatto,
        isPopUp: true,
        heightDetail: "390",
        heightTree: "703",
        sedeSelezionata: event.formData
      }
      this.componentService.setNewPopUp(guid, 'CrmDettagliProcedureContattiComponent', null, '1500', null, dataToSend, false, true, titolo, 'center', null)
      this.componentService.outputComponent.subscribe((res) => {

      })
    }
    //this.onAllEventEmitter.emit(event)
  }
  buttonEventAnagrafica(event) {
    const titolo = `Riepilogo Procedure di:  ${this.dataContatto.RagSoc}`
    let dataToSend = {
      queryString: `/${this.dataContatto.Cod}`,
      dataRelated: this.dataContatto,
      isPopUp: true,
      heightDetail: "390",
      heightTree: "703",
      sedeSelezionata: event.row.data
    }
    if (dataToSend.queryString !== undefined && dataToSend.dataRelated !== undefined) {
      let guid = Math.random().toString().replace("0.", "")
      this.componentService.setNewPopUp(guid, 'CrmDettagliProcedureContattiComponent', null, '1500', null, dataToSend, false, true, titolo, 'center', null)
      this.componentService.outputComponent.subscribe((res) => {

      })
    } else {
      alert("Non è possibile visualizzare il riepilogo delle procedure.", 'Attenzione')
    }
    //this.onAllEventEmitter.emit(event)
  }
}


